import validator from "../validators/validator";
import Content from "../components/ManagePrivateClassContent";
import { IWizardStep } from "../../../wizard/types";

export const createConfig: IWizardStep = {
  width: "712px",
  titleConfig: {
    titleText: "Add private class",
  },
  content: Content,
  validator: validator,
};
